import optinego from './optinego'
import ardoise from './ardoise'
import duomat from './duomat'
import duomatBleu from './duomat-bleu'

/**
 * Theme registry. To add a theme, create `./<id>.js` exporting a partial
 * theme object (missing keys fall back to the default theme) and register it.
 */
export const themes = { optinego, ardoise, duomat, 'duomat-bleu': duomatBleu }

/** Theme every other theme is deep-merged onto (provides all keys). */
export const BASE_THEME_ID = 'optinego'

/** Theme shown to everyone; staff can switch (see `resolveThemeId`). */
export const DEFAULT_THEME_ID = 'duomat'
